import Stat_Decor_1 from "../../img/decor/stat_decor_1.webp";
import Stat_Decor_2 from "../../img/decor/stat_decor_2.webp";
import Stat_Decor_3 from "../../img/decor/stat_decor_3.webp";
import Stat_Decor_4 from "../../img/decor/stat_decor_4.webp";



function Statistic() {
    const statisticContent = [
        {
            number: '30+',
            text: 'спікерів',
            icon: Stat_Decor_1,
            background: 'linear-gradient(108.96deg, rgba(251, 249, 170, 0.2) 9.73%, rgba(177, 241, 10, 0.2) 88.77%)'
        },
        {
            number: '4',
            text: 'панельні дискусії',
            icon: Stat_Decor_2,
            background: 'linear-gradient(103.91deg, rgba(210, 247, 245, 0.3) 40.37%, rgba(244, 144, 194, 0.3) 88.43%)'
        },
        {
            number: '500+',
            text: 'учасників офлайн',
            icon: Stat_Decor_3,
            background: 'linear-gradient(108.96deg, rgba(251, 249, 170, 0.2) 9.73%, rgba(177, 241, 10, 0.2) 88.77%)'
        },
        {
            number: '8000+',
            text: 'глядачів трансляції',
            icon: Stat_Decor_4,
            background: 'linear-gradient(103.91deg, rgba(210, 247, 245, 0.3) 40.37%, rgba(244, 144, 194, 0.3) 88.43%)'
        }
    ];

    return (
        <section className="mb-[60px] lg:mb-[90px] xl:mb-[120px]">
            <div className="container max-w-screen-xl mx-auto relative px-5">

                <div className="mb-9 md:mb-16 xl:mb-[85px] md:flex md:items-center md:gap-5 md:justify-between">
                    <div className="mb-[18px] flex flex-col items-center md:mb-0">
                        <span className="text-[66px] uppercase font-bold leading-none lg:text-[100px] xl:text-[134px]">
                            500+
                        </span>

                        <span className="font-light text-xl leading-none">
                            гостей
                        </span>
                    </div>

                    <div>
                        <div className="bg-[linear-gradient(90deg,#ff697b_45.19%,#ffed85_100%)] text-white p-5 text-2xl uppercase font-medium text-center mb-[18px] rounded-[40px]">
                            Топова подія для маркетологів та комунікаційників:
                        </div>

                        <p className="text-xl font-light text-center md:text-left md:pl-8 lg:max-w-[565px] lg:text-2xl">
                            насичений виступами, панельними дискусіями та нетворкінгом день
                        </p>
                    </div>
                </div>

                <div className="flex flex-col items-center gap-14 mb-12 md:flex-row md:justify-between md:gap-5 lg:mb-[80px]">
                    {statisticContent.map((item, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center justify-center overflow-hidden md:justify-between md:items-start
                                 relative gap-1 rounded-[15px] py-5 px-8 md:pb-9 w-full max-w-[300px] h-[200px] md:h-[230px]" style={{
                                    background: item.background
                                }}
                        >
                            <div className="">
                                <span className="text-6xl uppercase font-bold z-10 relative">
                                    {item.number}
                                </span>

                                <div
                                    className={`absolute top-0 right-0 h-full`}
                                >
                                    <img
                                        src={item.icon}
                                        alt={item.text}
                                        className="w-full object-cover"
                                    />
                                </div>
                            </div>

                            <p
                                className="z-10 relative text-2xl font-light text-center"
                                
                            >
                                {item.text}
                            </p>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    )
}
export default Statistic;